import { IMCell } from './typings';

export class MCell {
  text: string;
  source: IMCell;

  get x(): number {
    return this.source.x;
  }
  get y(): number {
    return this.source.y;
  }
  get width(): number {
    return this.source.width;
  }
  get height(): number {
    return this.source.height;
  }
  get pageNumber(): number {
    return this.source.page_number;
  }

  get error(): boolean {
    return this.source.error ?? false;
  } // 是否标记为错误位
  get highlight(): boolean {
    return this.source.highlight ?? false;
  } // 高亮
  get classnames(): string {
    return this.source.classnames ?? '';
  }
  get readonly(): boolean {
    return this.source.readonly ?? false; // 默认可编辑
  } // 只读

  constructor(source: IMCell) {
    this.source = source;
    this.text = source.text ?? '';
  }

  updateText(text: string): void {
    this.text = text;
    this.source.text = text;
  }

  toJson(): IMCell {
    return this.source;
  }
}
